import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { StatCounterComponent } from './stat-counter/stat-counter.component';
import { CtaStripComponent } from './cta-strip/cta-strip.component';
import { ContentSyncDirective } from './directives/content-sync.directive';
import { CenterActiveTabDirective, CenterOnClickDirective } from './directives/center-on-click.directive';
import { ScrollDotsDirective } from './directives/scroll-dots.directive';
import { IconComponent } from './icon/icon.component';
import { RecruitersLogoComponent } from './recruiters-logo/recruiters-logo.component';
import { ProgramShareComponent } from './program-share/program-share.component';
import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component';
import { ScrollActiveNavDirective } from './directives/scroll-active-nav.directive';
import { CdnImagePipe } from './pipes/cdn-image.pipe';

@NgModule({
  declarations: [
    StatCounterComponent,
    CtaStripComponent,
    ContentSyncDirective,
    CenterOnClickDirective,
    CenterActiveTabDirective,
    ScrollDotsDirective,
    IconComponent,
    RecruitersLogoComponent,
    ProgramShareComponent,
    PhotoGalleryComponent,
    ScrollActiveNavDirective,
    CdnImagePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    StatCounterComponent,
    CtaStripComponent,
    ContentSyncDirective,
    CenterOnClickDirective,
    CenterActiveTabDirective,
    ScrollDotsDirective,
    IconComponent,
    RecruitersLogoComponent,
    ProgramShareComponent,
    PhotoGalleryComponent,
    ScrollActiveNavDirective,
    CdnImagePipe
  ]
})
export class SharedModule { }
